module.exports = {
	"title": "CSS text-size-adjust",
	"description": "On mobile devices, the text-size-adjust CSS property allows Web authors to control if and how the text-inflating algorithm is applied to the textual content of the element it is applied to.",
	"spec": "http://dev.w3.org/csswg/css-size-adjust/",
	"status": "unoff",
	"links": [
		{
			"url": "https://developer.mozilla.org/en-US/docs/Web/CSS/text-size-adjust",
			"title": "MDN Docs"
		}
	],
	"bugs": [],
	"categories": [
		"CSS3"
	],
	"stats": {
		"ie": {
			"6": "n",
			"7": "n",
			"8": "n",
			"9": "n",
			"10": "n",
			"11": "n",
			"5.5": "n"
		},
		"edge": {
			"12": "n",
			"13": "n",
			"14": "n"
		},
		"firefox": {
			"2": "n",
			"3": "n",
			"4": "n",
			"5": "n",
			"6": "n",
			"7": "n",
			"8": "n",
			"9": "n",
			"10": "n",
			"11": "n",
			"12": "n",
			"13": "n",
			"14": "n",
			"15": "n",
			"16": "n",
			"17": "n",
			"18": "n",
			"19": "n",
			"20": "n",
			"21": "n",
			"22": "n",
			"23": "n",
			"24": "n",
			"25": "n",
			"26": "n",
			"27": "n",
			"28": "n",
			"29": "n",
			"30": "n",
			"31": "n",
			"32": "n",
			"33": "n",
			"34": "n",
			"35": "n",
			"36": "n",
			"37": "n",
			"38": "n",
			"39": "n",
			"40": "n",
			"41": "n",
			"42": "n",
			"43": "n",
			"44": "n",
			"45": "n",
			"46": "n",
			"47": "n",
			"48": "n",
			"49": "n",
			"50": "n",
			"51": "n",
			"52": "n",
			"53": "n",
			"3.5": "n",
			"3.6": "n"
		},
		"chrome": {
			"4": "n",
			"5": "n",
			"6": "n",
			"7": "n",
			"8": "n",
			"9": "n",
			"10": "n",
			"11": "n",
			"12": "n",
			"13": "n",
			"14": "n",
			"15": "n",
			"16": "n",
			"17": "n",
			"18": "n",
			"19": "n",
			"20": "n",
			"21": "n",
			"22": "n",
			"23": "n",
			"24": "n",
			"25": "n",
			"26": "n #2",
			"27": "n",
			"28": "n",
			"29": "n",
			"30": "n",
			"31": "n",
			"32": "n",
			"33": "n",
			"34": "n",
			"35": "n",
			"36": "n",
			"37": "n",
			"38": "n",
			"39": "n",
			"40": "n",
			"41": "n",
			"42": "n",
			"43": "n",
			"44": "n",
			"45": "n",
			"46": "n",
			"47": "n",
			"48": "n",
			"49": "n",
			"50": "n",
			"51": "n",
			"52": "n",
			"53": "n",
			"54": "y",
			"55": "y",
			"56": "y",
			"57": "y"
		},
		"safari": {
			"4": "n",
			"5": "n",
			"6": "n",
			"7": "n",
			"8": "n",
			"9": "n",
			"10": "n",
			"3.1": "n",
			"3.2": "n",
			"5.1": "n #2",
			"6.1": "n",
			"7.1": "n",
			"9.1": "n",
			"TP": "n"
		},
		"opera": {
			"9": "n",
			"11": "n",
			"12": "n",
			"15": "n",
			"16": "n",
			"17": "n",
			"18": "n",
			"19": "n",
			"20": "n",
			"21": "n",
			"22": "n",
			"23": "n",
			"24": "n",
			"25": "n",
			"26": "n",
			"27": "n",
			"28": "n",
			"29": "n",
			"30": "n",
			"31": "n",
			"32": "n",
			"33": "n",
			"34": "n",
			"35": "n",
			"36": "n",
			"37": "n",
			"38": "n",
			"39": "n",
			"40": "n",
			"41": "n",
			"42": "n",
			"43": "n",
			"9.5-9.6": "n",
			"10.0-10.1": "n",
			"10.5": "n",
			"10.6": "n",
			"11.1": "n",
			"11.5": "n",
			"11.6": "n",
			"12.1": "n"
		},
		"ios_saf": {
			"8": "y x",
			"10": "y x",
			"3.2": "n",
			"4.0-4.1": "n",
			"4.2-4.3": "n",
			"5.0-5.1": "y x",
			"6.0-6.1": "y x",
			"7.0-7.1": "y x",
			"8.1-8.4": "y x",
			"9.0-9.2": "y x",
			"9.3": "y x"
		},
		"op_mini": {
			"all": "n"
		},
		"android": {
			"3": "n",
			"4": "n",
			"53": "n",
			"2.1": "n",
			"2.2": "n",
			"2.3": "n",
			"4.1": "n",
			"4.2-4.3": "n",
			"4.4": "n",
			"4.4.3-4.4.4": "n"
		},
		"bb": {
			"7": "n",
			"10": "n"
		},
		"op_mob": {
			"10": "n",
			"11": "n",
			"12": "n",
			"37": "n",
			"11.1": "n",
			"11.5": "n",
			"12.1": "n"
		},
		"and_chr": {
			"53": "n"
		},
		"and_ff": {
			"49": "y x"
		},
		"ie_mob": {
			"10": "y x #1",
			"11": "y x #1"
		},
		"and_uc": {
			"11": "y x"
		},
		"samsung": {
			"4": "n"
		}
	},
	"notes": "",
	"notes_by_num": {
		"1": "If the viewport size is set using a `<meta>` element, the `-ms-text-size-adjust` property is ignored. See [MSDN](https://msdn.microsoft.com/en-us/library/ie/dn793579%28v=vs.85%29.aspx)",
		"2": "Old versions of WebKit-based desktop browsers (Chrome<27, Safari<6) [suffer from a bug](https://bugs.webkit.org/show_bug.cgi?id=56543) where if `-webkit-text-size-adjust` is explicitly set to `none`, instead of ignoring the property, the browsers will prevent the user from zooming in or out on the webpage."
	},
	"usage_perc_y": 23.69,
	"usage_perc_a": 0,
	"ucprefix": false,
	"parent": "",
	"keywords": "",
	"ie_id": "",
	"chrome_id": "5730156303876096",
	"firefox_id": "",
	"webkit_id": "",
	"shown": true
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/features-json/text-size-adjust.json
 ** module id = 451
 ** module chunks = 0
 **/